import React, { FC } from 'react';
import { useRouter } from 'next/router';
import { Breadcrumbs, Stack, Typography, styled } from '@mui/material';
import { findLocalCategoryById, getSeoDataByCategory } from '@/Services/SEO/category-seo';
import { useTranslation } from 'next-i18next';
import { getNameKeyByLang } from '@/Utils/getNameKeyByLang';
import AngleRight from '@/Components/atoms/CommonSvg/angleRight';
import Link from 'next/link';
import { categoryService } from '@/Models/Category/category.service';
import { useGetCategories } from '@/ServerState/hooks/useGetCategories';
import { logger } from '@/Services/Logger';

type Props = {};

const Style = styled('div')`
  a,
  h1 {
    text-decoration: none;
    color: #000;
    font-size: 12px;
    margin: 0;
    font-weight: 500;
    font-family: Inter;
    color: rgba(12, 136, 198, 1);
  }

  .last-breadcrumb {
    color: rgba(0, 4, 15, 1);
  }

  svg {
    height: 8px;
    width: 8px;
    path {
      fill: rgba(195, 198, 207, 1);
    }
  }
`;

// TODO FIX WITH ADDRESS CATEGORY PAGE
const CategoryProductsHeader: FC<Props> = () => {
  // @ts-ignore
  const { t, i18n } = useTranslation();
  const language = i18n.language as 'uz' | 'ru';
  const router = useRouter();
  const categorySlug = router.query.categorySlug as string;
  const categoryId = categoryService.getValueFromSlug(categorySlug);
  const getCategoriesQuery = useGetCategories();

  const data = getCategoriesQuery?.data?.data || [];

  const categoryObj = findLocalCategoryById(categoryId)!;
  const categoryObjSeo = getSeoDataByCategory(categoryObj, t);

  // @ts-ignore
  const findCategoryById = (id, categories) => {
    for (const category of categories) {
      if (category.id === id) {
        return category;
      }
      if (category.childs.length > 0) {
        // @ts-ignore
        const foundCategory = findCategoryById(id, category.childs);
        if (foundCategory) {
          return foundCategory;
        }
      }
    }
    return null;
  };

  const category = findCategoryById(categoryId, data);

  const names = [];
  if (category) {
    let currentCategory = category;
    while (currentCategory) {
      names.unshift({
        name: currentCategory[getNameKeyByLang(language)],
        id: currentCategory.id,
      });
      currentCategory = findCategoryById(currentCategory.parentId, data);
    }
  } else {
    logger.log('Kategoriya topilmadi');
  }

  

  return (
    <Style>
      <Stack spacing={2} direction={'row'} alignItems={'center'}>
        <Breadcrumbs separator={<AngleRight style={{ marginTop: '2px' }} />} aria-label='breadcrumb'>
          <Link href={'/'}>{t('home')}</Link>
          {names.map((item, index) =>
            index === names.length - 1 ? (
              <Typography key={index} component={'a'} variant='h5' className={'last-breadcrumb'}>
                {item.name}
              </Typography>
            ) : (
              <Link key={index} href={`/category/${findLocalCategoryById(item.id)?.url}`}>
                {item.name}
              </Link>
            )
          )}
        </Breadcrumbs>
      </Stack>
    </Style>
  );
};

export default CategoryProductsHeader;

function getIdByString(url: string): number {
  const strs = url.split('-');
  return +strs[strs.length - 1];
}
